import { defineMessages } from 'react-intl';

const messages = defineMessages({
  headLine_text_one: {
    id: 'pf85Fq',
    defaultMessage:
      'Explore IBM QRadar Security Software, with estimated pricing starting at',
  },
  footnotes: {
    id: 't1Ql7Y',
    defaultMessage: 'Footnotes',
  },
  footnote_one: {
    id: 'biioPT',
    defaultMessage:
      'Calculated prices are estimates provided for planning purposes only taking into account potential IBM discounts, and are not a formal offer from IBM or an IBM Business Partner. The estimation may reflect the total discounted price. Certain factors such as configuration, add-ons, or additional requirements will affect final price. IBM Business Partners set and provide their own IBM QRadar SIEM (Classic) pricing, and neither IBM nor IBM Business Partners are bound by the provided estimate.',
  },
  'thankyou.title': {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  'thankyou.subtitle': {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  'thankyou.details-employees': {
    id: '+YXKBO',
    defaultMessage: 'Total Workstations or Employees',
  },
  'thankyou.details-servers': {
    id: '+YXKBO',
    defaultMessage: 'Total Workstations or Employees',
  },
  'thankyou.details-monthly-cost': {
    id: 'wNB/GH',
    defaultMessage: 'Estimated monthly cost',
  },
  'thankyou.details-NDR': {
    id: 'd7PrE3',
    defaultMessage: 'Include QRadar NDR',
  },
  'thankyou.details-delivery': {
    id: '7UbQM1',
    defaultMessage: 'Delivery Option',
  },
  'thankyou.details-selected-bp': {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  'thankyou.details-consent-bp': {
    id: 'oZz635',
    defaultMessage:
      'I consent to IBM providing my business contact information',
  },
  'thankyou.details-title': {
    id: 'NWIE97',
    defaultMessage: 'Request details',
  },
  'return-to-estimator': {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  'drawer-close': {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  'footnote-headline-two': {
    id: '5PlN0b',
    defaultMessage: 'Total Servers in the Environment',
  },
  'footnote-physical-server': {
    id: 'H8/10h',
    defaultMessage:
      'A physical server is typically a physical computer that is comprised of processing units, memory, and input/output capabilities and that executes requested procedures, commands, or applications for one or more users or client devices. Where racks, blade enclosures, or other similar equipment is being employed, each separable physical device (for example, a blade or a rack-mounted device) that has the required components is considered itself a separate server.',
  },
  'footnote-virtual-server': {
    id: '507u0l',
    defaultMessage:
      'A virtual server is a virtual computer created by logically partitioning physical resources into sub-computers that execute requested procedures, commands, or applications for one or more users or client devices.',
  },
  handling_title: {
    id: 'g7hhSR',
    defaultMessage: "Sorry, this shouldn't happen.",
  },
  handling_details1: {
    id: '8Kj9tz',
    defaultMessage: 'Unable to load price for',
  },
  handling_details2: {
    id: 'Md2HqZ',
    defaultMessage: 'Fetching local prices instead.',
  },
  handling_contact: {
    id: 'WnQ/AZ',
    defaultMessage: 'Contact us',
  },
  headline_question: {
    id: 'nmcIgr',
    defaultMessage: 'Which solution best fits your needs?',
  },
  headline_header: {
    id: 'd88bOo',
    defaultMessage: 'IBM QRadar SIEM (SaaS) vs IBM QRadar SIEM (Software)',
  },
  subheadline_saas: {
    id: 'UiH2EC',
    defaultMessage: 'SIEM (SaaS)',
  },
  saas_bullet_one: {
    id: 'rZ09DP',
    defaultMessage:
      'All the benefits of QRadar SIEM without needing to invest in hardware and software',
  },
  saas_bullet_two: {
    id: 'o5JA5p',
    defaultMessage: 'Supported on multiple public cloud platforms',
  },
  saas_bullet_three: {
    id: 'wdxsJ3',
    defaultMessage: 'Faster deployment',
  },
  saas_bullet_four: {
    id: 'uF0TIM',
    defaultMessage: 'Continuous product updates',
  },
  saas_bullet_five: {
    id: 'U4LG6N',
    defaultMessage: 'Offload IT management to the experts',
  },
  subheadline_sws: {
    id: 'OhgUC+',
    defaultMessage: 'SIEM (Software)',
  },
  sws_bullet_one: {
    id: 'qxpW4e',
    defaultMessage:
      'Enables more control over your SIEM, while avoiding sharing data with cloud providers',
  },
  sws_bullet_two: {
    id: 'jODAwH',
    defaultMessage: 'Ability to remain on a CapEx model',
  },
  sws_bullet_three: {
    id: 'gUzGh0',
    defaultMessage: 'Data residency requirements',
  },
  sws_bullet_four: {
    id: 'tQekMg',
    defaultMessage: 'Easily meet specific performance requirements',
  },
  sws_bullet_five: {
    id: 'AmPGyH',
    defaultMessage: 'Total control of upgrade cycle',
  },
  sws_bullet_six: {
    id: 'krQzxD',
    defaultMessage: 'Purchase as a part of a CapEx model, rather than OpEx',
  },
  bp_mssp: {
    id: 'Aqo5HL',
    defaultMessage:
      'can help you deploy this solution with their managed services, helping you respond to incidents so you can focus on your business.',
  },
  estimated_price: {
    id: 'DwkFzf',
    defaultMessage: 'Estimate your solution size',
  },
  contactBP: {
    id: 'SWi5iE',
    defaultMessage: 'Business Partner: ',
  },
  scoping_questions: {
    id: 'SLvWs/',
    defaultMessage: 'Size your solution',
  },
  ndr_no: {
    id: 'HUuKu5',
    defaultMessage: 'Exclude QRadar NDR',
  },
  ndr_yes: {
    id: 'd7PrE3',
    defaultMessage: 'Include QRadar NDR',
  },
  labeltext_servers: {
    id: '5PlN0b',
    defaultMessage: 'Total Servers in the Environment',
  },
  triggertext_workstations: {
    id: '+YXKBO',
    defaultMessage: 'Total Workstations or Employees',
  },
  asterisk_price: {
    id: 'tAGhWW',
    defaultMessage:
      'Price represents a usage model, based off of events per second (EPS) and do not include tax.',
  },
  estimated_costs: {
    id: 'wNB/GH',
    defaultMessage: 'Estimated monthly cost',
  },
  contact_us: {
    id: 'WnQ/AZ',
    defaultMessage: 'Contact us',
  },
  welcome_msg_1: {
    id: 'SZYF87',
    defaultMessage:
      'Find the right size for your solution and estimate your IBM QRadar',
  },
  price: {
    id: 'L3kuII',
    defaultMessage: 'price',
  },
  scoping_text: {
    id: 'IQtpae',
    defaultMessage:
      'When you provide the size of your organization, we can estimate an approximate QRadar price, based on the needs of other clients of similar size. This will be a “rough estimate,” only a specialist will help you with a customized quote.',
  },
  more_info: {
    id: 'y6FZ6y',
    defaultMessage: 'More Information',
  },
  tooltip_ndr: {
    id: '15QrIR',
    defaultMessage:
      'Include QRadar NDR to monitor network data and expose hidden security threats',
  },
  tooltip_ndr_info: {
    id: 'HpwB7t',
    defaultMessage:
      'To learn more about QRadar Network Detection and  Response visit',
  },
  no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  preferred_bp: {
    id: '9Auwhe',
    defaultMessage: 'Preferred IBM Business Partner',
  },
  inline_sws: {
    id: 'CI1KvW',
    defaultMessage: 'Software subscription information',
  },
  inline_saas: {
    id: 'pzhawg',
    defaultMessage: 'Software as a Service information',
  },
  subtitle_sws: {
    id: 'mQxRPU',
    defaultMessage: 'Pricing does not include the cost of infrastructure.',
  },
  role: {
    id: 'FCjGve',
    defaultMessage: 'Requirement',
  },
  licences: {
    id: 'qVGRIE',
    defaultMessage: 'Quantity',
  },
  tooltip_workstations: {
    id: 'LzpZFf',
    defaultMessage: 'If your organization has more than 10000 employees please',
  },
  request_a_quote: {
    id: 'aAghQx',
    defaultMessage: 'Request a quote now',
  },
  modalContinue: {
    id: 'acrOoz',
    defaultMessage: 'Continue',
  },
});

export default messages;
